import init from 'rev.sdk.js/Config/featureOptions';

init({points: {}, coupon: {}, facebookPixel: {}, googleAnalytics: {}});
